<template>
    <el-dialog class="dialog-box" title="审批详情"  v-if="outerForm" :visible.sync="outerForm" top="5vh" @close="handleCancel">
        <!-- 表格 信息 -->
        <el-card class="box-card" shadow="never" v-if="type == 0">
            <div slot="header" class="title-box">
                <span>发起人</span>
            </div>

            <el-table class="grayTableTile"  v-loading="listLoading" :data="promoterList" border style="width: 100%">
                <el-table-column label="注册账号" min-width="110px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.username}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="真实姓名" min-width="100px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.realname}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="企业邮箱" min-width="150px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.email}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="所属公司" min-width="100px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.company}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="所属部门" min-width="100px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.department}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="职位" min-width="100px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.position}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <el-card class="box-card" shadow="never">
            <div slot="header" class="title-box">
                <span>申请人</span>
            </div>

            <el-table class="grayTableTile"  v-loading="listLoading" :data="applicantList" border style="width: 100%">
                <el-table-column label="申请类型" min-width="80px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.type | typeMap}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="注册账号" min-width="110px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.username}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="真实姓名" min-width="90px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.realname}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="企业邮箱" min-width="220px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.email}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="所属公司" min-width="100px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.company}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="所属部门" min-width="100px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.department}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="职位" min-width="100px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.position}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="申请游戏" min-width="220px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.gameName}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="申请原因" min-width="220px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.applyReason}}</span>
                    </template>
                </el-table-column>

            </el-table>
        </el-card>

        <!-- 流程 -->
        <el-card class="box-card" shadow="never">
            <div slot="header" class="title-box">
                <span>流程记录</span>
            </div>
           
            <div style="height:70px">
                <el-timeline>
                    <el-timeline-item color="#008000">{{steps.promoterAddTime}} &nbsp;&nbsp;&nbsp; {{steps.realname}} &nbsp;&nbsp;&nbsp; 提交申请</el-timeline-item>
                    <el-timeline-item color="#ffb83d">
                        <span>{{steps.addTime}} &nbsp;&nbsp;&nbsp; {{steps.approverName}} &nbsp;&nbsp;&nbsp; {{steps.status | statusMap}}  &nbsp;&nbsp;&nbsp; {{steps.rejectDesc? '原因：' + steps.rejectDesc : ''}}</span>
                        <el-button size="mini" type="primary" style="margin-left: 10px" @click="handleOpenDetails" v-if="steps.status == 1">
                            权限明细
                            <i class="el-icon-arrow-down el-icon--right" v-if="!isDetails"></i>
                            <i class="el-icon-arrow-up el-icon--right" v-else></i>
                        </el-button>
                    </el-timeline-item>
                </el-timeline>

            </div>
        </el-card>

        <!-- 开通 拒绝 操作按钮 -->
        <div class="butn-box" style="margin:10px auto; text-align:center" v-if="source == 'approve' && details.status == 0">
            <el-popover placement="top" width="300" v-model="visible">
                <el-input type="textarea" v-model="reason" placeholder="原因" style="margin-bottom:10px"></el-input>
                <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="visible = false" style="color:#8c8c8c">取消</el-button>
                    <el-button size="mini" type="text" :loading="refuseLoding" @click="handleRefuse">确定</el-button>
                </div>
                <el-button slot="reference" size="small">拒绝开通</el-button>
            </el-popover>

            <el-button size="small" type="primary" style="margin: 0 20px" :loading="openLoding" @click="handleOpen">选择开通的权限</el-button>
        </div>
        
        <!--明细 -->
        <el-card class="box-card" shadow="never" v-if="isDetails">
            <div slot="header" class="title-box">
                <span>开通权限明细</span>
            </div>

            <div class="list-box">
                <div class="filter-container">
                    <div class="item filter-item">
                        <label>游戏：</label>
                        <span class="title">{{details.gameName}}</span>
                    </div>

                    <!-- <div class="item filter-item">
                        <el-button type="text" @click="jumpLink" v-if="source == 'approve'">自定义角色</el-button>
                        <el-popover v-if="source == 'approve'" placement="right" width="300" trigger="hover" content="如果现有预设角色不满足需求，可通过自定义角色分配任意菜单和渠道">
                            <bdc-help-icon slot="reference" :size="15" style="cursor: pointer; margin-left:10px" />
                        </el-popover>
                    </div> -->

                    <div class="item filter-item all-item" :class="source == 'approve' && details.status == 0 ? 'select-item' : ''">
                        <label>
                            <el-popover placement="right" width="300" trigger="hover" content="如预设角色不满足需求，可联系相应对接人创建自定义角色">
                            <bdc-help-icon slot="reference" :size="15" style="cursor: pointer; margin-left:10px" />
                        </el-popover>
                            角色：</label>
                        <!-- <el-select size="small" v-model="roles" multiple collapse-tags filterable clearable placeholder="项目" style="width:200px;" @change="getPermissions" v-if="source == 'approve' && details.status == 0">
                            <el-option v-for="item in rolesOptions" :key="item.id" :label="item.title" :value="item.id"></el-option>
                        </el-select> -->
                        <!-- 角色选择 -->
                        <transfer-roles ref="roles" @changeRoles="getPermissions" v-if="source == 'approve' && details.status == 0"></transfer-roles>
                        <span class="title" v-else>{{rolesName}}</span>
                    </div>

                   
                </div>

                <el-row class="all" :gutter="24" v-if="permissionsList.length > 0">
                    <el-col :sm="1" :md="1" :lg="3" style="width: 122px"><label style="line-height:36px">角色权限明细：</label></el-col>
                    <el-col :sm="23" :md="23" :lg="21">
                        <el-collapse class="collapse-box" v-model="activeNames" accordion>
                            <el-collapse-item v-for="(item,index) in permissionsList" :title="item.roleName" :name="index" :key="item.roleId">
                                <el-row class="all falls-box" :gutter="24">
                                    <!-- 菜单 -->
                                    <el-col class="falls-item" :md="12" :lg="12" v-if="item.menus && item.menus.length > 0">
                                        <el-card shadow="never" class="card">
                                            <div slot="header" class="title-box">
                                                <span style="font-weight:100">菜单权限</span>
                                            </div>
                                            <el-tree
                                                :data="item.menus"
                                                node-key="id"
                                                :props="defaultProps">
                                            </el-tree>
                                        </el-card>
                                    </el-col>
                                   
                                    <!-- 渠道 -->
                                    <el-col class="falls-item" :md="12" :lg="12" v-if="item.channels && item.channels.length > 0">
                                        <el-card shadow="never" class="card">
                                            <div slot="header" class="title-box">
                                                <span style="font-weight:100">渠道权限</span>
                                            </div>
                                            <el-tree
                                                :data="item.channels"
                                                node-key="id"
                                                :props="defaultProps">
                                            </el-tree>
                                        </el-card>
                                    </el-col>

                                    <!-- 媒体 -->
                                    <el-col class="falls-item" :md="12" :lg="12" v-if="item.medias && item.medias.length > 0">
                                        <el-card shadow="never" class="card">
                                            <div slot="header" class="title-box">
                                                <span style="font-weight:100">媒体权限</span>
                                            </div>
                                            <el-tree
                                                :data="item.medias"
                                                node-key="id"
                                                :props="defaultProps">
                                            </el-tree>
                                        </el-card>
                                    </el-col>

                                    <!-- 监测 -->
                                    <el-col class="falls-item" :md="12" :lg="12" v-if="item.monitors && item.monitors.length > 0">
                                        <el-card shadow="never" class="card">
                                            <div slot="header" class="title-box">
                                                <span style="font-weight:100">监测权限</span>
                                            </div>
                                            <el-tree
                                                :data="item.monitors"
                                                node-key="id"
                                                :props="defaultProps">
                                            </el-tree>
                                        </el-card>
                                    </el-col>

                                    <!-- 指标 -->
                                    <el-col class="falls-item" :md="12" :lg="12" v-if="item.indexs && item.indexs.length > 0">
                                        <el-card shadow="never" class="card">
                                            <div slot="header" class="title-box">
                                                <span style="font-weight:100">指标权限</span>
                                            </div>
                                            <el-tree
                                                :data="item.indexs"
                                                node-key="id"
                                                :props="defaultProps">
                                            </el-tree>
                                        </el-card>
                                    </el-col>

                                    <!-- 功能点 -->
                                    <el-col class="falls-item" :md="12" :lg="12" v-if="item.points && item.points.length > 0">
                                        <el-card shadow="never" class="card">
                                            <div slot="header" class="title-box">
                                                <span style="font-weight:100">功能点权限</span>
                                            </div>
                                            <el-tree
                                                :data="item.points"
                                                node-key="id"
                                                :props="defaultProps">
                                            </el-tree>
                                        </el-card>
                                    </el-col>

                                    <!-- 用户来源 -->
                                    <el-col class="falls-item" :md="12" :lg="12" v-if="item.userSources && item.userSources.length > 0">
                                        <el-card shadow="never" class="card">
                                            <div slot="header" class="title-box">
                                                <span style="font-weight:100">用户来源权限</span>
                                            </div>
                                            <el-tree
                                                :data="item.userSources"
                                                node-key="id"
                                                :props="defaultProps">
                                            </el-tree>
                                        </el-card>
                                    </el-col>

                                    <!-- 国家 -->
                                    <el-col class="falls-item" :md="12" :lg="12" v-if="item.country && item.country.length > 0">
                                        <el-card shadow="never" class="card">
                                            <div slot="header" class="title-box">
                                                <span style="font-weight:100">国家维度权限</span>
                                            </div>
                                            <el-tree
                                                :data="item.country"
                                                node-key="id"
                                                :props="defaultProps">
                                            </el-tree>
                                        </el-card>
                                    </el-col>
                                    

                                </el-row>

                            </el-collapse-item>
                        </el-collapse>
                    </el-col>
                </el-row>
            </div>

            <div class="dialog-butn-box" style="margin: 10px 20px 10px" v-if="source == 'approve' && details.status == 0">
                <el-button size="small" type="primary" :loading="saveLoding" @click="handleSave">同意开通</el-button>
                <el-button  size="small" @click="handleCancel">取消</el-button>
            </div>
        </el-card>
    </el-dialog>
</template>

<script>
import { ajax_myApplyDetail,ajax_refuse, ajax_permissions, ajax_roles, ajax_beginApply, ajax_passApply, ajax_cancelApply} from '@Sys~/api/sys'
import TransferRoles from './transferRoles.vue'
export default {
    components: {TransferRoles},
    data() {
        return {

            outerForm: false,
            source: '',
            infos: {}, // 每条数据记录
            
            // 表格
            listLoading: false,

            type:null, // 判断是否代理申请
            promoterList: [],// 发起人
            applicantList:[], // 申请人

            steps:{}, // 流程记录

            details:{}, // 详情

            rolesOptions: [], // 角色集合
            roles:[], // 当前选中的角色
            rolesName:'',

            permissionsList :[], // 权限明细

            defaultProps: {
                children: 'childs',
                label: 'name'
            },

            activeNames: 0,
            isDetails: false,

            // 拒绝开通
            visible: false,
            reason:'', // 原因
            refuseLoding:false,

            // 开通权限
            openLoding: false,
            saveLoding: false

        }
    },

    filters: {
        // 申请类型
        typeMap(type){
            const typeMap = {
              0 : '代理申请',
              1 : '本人申请'
            }
            return typeMap [type]
        },

        // 流程状态
        statusMap(status) {
            const statusMap = {
              0 : '待审核',
              1 : '已完成',
              '-1': '已删除',
              2: '正在审核',
              3: '被驳回'
            }
            return statusMap [status]
        }
    },

    methods: {
        init(row,source) {
            this.outerForm = true
            this.listLoading = false
            this.infos = row
            this.source = source
            
            this.details = {}
            this.type = null
            this.promoterList = []
            this.applicantList = []
            this.steps = {}

            this.rolesOptions = [] // 角色集合
            this.roles = []
            this.rolesName = ''

            this.permissionsList = []
            this.activeNames = 0

            this.isDetails = false
            this.visible = false
            this.reason = ''
            this.refuseLoding = false
            this.openLoding = false
            this.saveLoding = false
            
            this.getDetails() // 获取详情

        },

        // 跳转
        jumpLink() {
            this.$router.push('/fangwenkongzhi/jueseguanli')
        },

        // 获取详情
        getDetails() {
            this.listLoading = true
            ajax_myApplyDetail(this.infos.id).then(response => {
               this.listLoading = false
                if(response.code == 1) {
                    this.details = JSON.parse(JSON.stringify(response.data))
                    this.type = response.data.type // 申请类型
                    this.roles = response.data.roles ? response.data.roles.split(',') : []
                    this.rolesName = response.data.roleName
                    // 申请人
                    this.applicantList = [ 
                        {
                            type: response.data.type,
                            username: response.data.applicantUser.username,
                            realname: response.data.applicantUser.realname,
                            email: response.data.applicantUser.email,
                            company: response.data.applicantUser.company,
                            department: response.data.applicantUser.department,
                            position: response.data.applicantUser.position,
                            gameName: response.data.gameName,
                            applyReason: response.data.applyReason
                        }
                      
                    ]

                    // 发起人
                    this.promoterList = [ 
                        {
                            username: response.data.promoterUser.username,
                            realname: response.data.promoterUser.realname,
                            email: response.data.promoterUser.email,
                            company: response.data.promoterUser.company,
                            department: response.data.promoterUser.department,
                            position: response.data.promoterUser.position
                        }
                    ]

                    // 流程
                    this.steps = {
                        addTime: response.data.updateTime,
                        promoterAddTime: response.data.addTime,
                        realname: response.data.promoterUser.realname,
                        approverName: response.data.approverName,
                        status: response.data.status,
                        rejectDesc:response.data.rejectDesc
                    }
                }
           })
        },

        // 获取游戏角色集合
        getRoles() {
            const data = {
                gameKey: this.details.gameKey,
                type:process.env.VUE_APP_PROJECT_TYPE
            }
            ajax_roles(data).then(response => {
                this.$refs['roles'].sourceList.toSelectedList.treeload = false
                if(response.code == 1) {
                  this.rolesOptions = response.data
                  if(response.data.length > 0) {
                    this.$refs['roles'].sourceList.toSelectedList.disabledSearch = false
                  }
                  this.$refs['roles'].sourceList.toSelectedList.list = this.$refs['roles'].transformList(response.data)
                }
            })
        },

        // 查询角色权限详情
        getPermissions() {
            if(this.$refs['roles']) {
                const resultList = this.$refs['roles'].sourceList.selectedList.list
                let roles = []
                resultList.forEach(item => {
                    roles.push(item.id)
                });
                this.roles = roles
            }
            const data = {
                system: process.env.VUE_APP_PROJECT_TYPE,
                authId: this.infos.id,
                appkey: this.details.appkey,
                gameKey:this.details.gameKey,
                roles: this.roles
            }
            ajax_permissions(data).then(response => {
                if(response.code == 1) {
                    // this.permissionsList = response.data
                    const data = JSON.parse(JSON.stringify(response.data))
                    this.permissionsList = data.map(v => {
                        if(v.menus && v.menus.length > 0) { // 菜单
                            v.menus = this.transformData(v.menus)
                        }

                        if(v.channels && v.channels.length > 0) { // 渠道
                            v.channels = this.transformData(v.channels)
                        }

                        if(v.medias && v.medias.length > 0) { // 媒体
                            v.medias = this.transformData(v.medias)
                        }

                        if(v.monitors && v.monitors.length > 0) { // 监测
                            v.monitors = this.transformData(v.monitors)
                        }

                        if(v.indexs && v.indexs.length > 0) { // 指标
                            v.indexs = this.transformData(v.indexs)
                        }

                        if(v.points && v.points.length > 0) { // 功能点
                            v.points = this.transformData(v.points)
                        }

                        if(v.userSources && v.userSources.length > 0) { // 用户来源
                            v.userSources = this.transformData(v.userSources)
                        }

                        if(v.country && v.country.length > 0) { // 国家
                            v.country = this.transformData(v.country)
                        }
                        
                        
                        return v
                    })
                }
            })
        },

        // 转换权限明细数据
        transformData(list) {
            return list.map(item => {
                this.$set(item,'disabled',true)
                if(item.childs && item.childs.length > 0) {
                    this.transformData(item.childs)
                }
                return item
            })
        },
        
        // 打开权限明细
        handleOpenDetails() {
            this.isDetails = !this.isDetails
            this.getPermissions() // 查询角色权限详情
        },

        // 拒绝开通
        handleRefuse() {
            if(!this.reason) {
                this.$message({
                    message: '请添加拒绝原因',
                    type: 'error'
                });
                return 
            }
            this.refuseLoding = true
            ajax_refuse(this.details.id, this.reason).then(response => {
                this.refuseLoding = false
                if(response.code == 1) {
                   this.visible = false
                   this.outerForm = false
                   this.$emit('reList')
                }
            })
        },

        // 开通权限
        handleOpen() {
            this.openLoding = true
            ajax_beginApply(this.details.id).then(response => {
                this.openLoding = false
                if(response.code == 1) {
                    this.isDetails = !this.isDetails
                    this.getRoles() // 获取游戏角色集合
                }
            })
        },

        // 取消
        handleCancel() {
            if(this.source == 'approve' && (this.details.status == 0 || this.details.status == 2 )) {
                ajax_cancelApply(this.details.id).then(response => {
                    if(response.code == 1) {
                        this.outerForm = false
                        this.$emit('reList')
                    }
                })
            }
        },

        // 确定
        handleSave() {
            this.saveLoding = true

            if(this.$refs['roles']) {
                const resultList = this.$refs['roles'].sourceList.selectedList.list
                let roles = []
                resultList.forEach(item => {
                    roles.push(item.id)
                });
                this.roles = roles
            }

            const data = {
                authId: this.infos.id,
                appkey: this.details.appkey,
                gameKey:this.details.gameKey,
                roles: this.roles
            }
            ajax_passApply(data).then(response => {
                this.saveLoding = false
                if(response.code == 1) {
                    this.$message({
                        message: '开通权限成功',
                        type: 'success'
                    });
                    this.outerForm = false
                    this.$emit('reList')
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .dialog-box{
        
        ::v-deep .el-dialog{
            width: calc(100vw - 15vw);
            height: auto;
            max-height: calc(100% - 10vh);
            overflow:auto;
        }
        ::v-deep .el-dialog__header{
            padding: 10px 10px 0;
            line-height: 30px;
            width: calc(100vw - 15vw);
            min-width: 600px;
            position: fixed;
            z-index: 99;
            background: #ffffff;
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        }
        ::v-deep .el-dialog__headerbtn{
            top: 10px;
        }
        ::v-deep .el-dialog__body{
            padding: 0 0 20px;
            margin-top: 40px;
        }
    }
    
    .box-card{
        border:none;
        ::v-deep .el-card__header{
            padding: 10px 20px;
            font-weight: bolder;
        }
        ::v-deep .el-card__body{
            padding: 10px 20px;
        }

        ::v-deep .el-select__tags{
            .el-tag {
                max-width: 84%;
                overflow: hidden;
                display: flex;
                flex-flow: row nowrap;
                justify-content: space-between;
                align-items: center;
                .el-select__tags-text{
                    width: 100%;
                    overflow: hidden;
                }
            }
            .el-select__input{
                margin-left: 2px;
            }
        }

        ::v-deep .el-step__title{
            font-size: 14px;
        }

        .list-box{
            // display: flex;
            // flex-flow: row wrap;
            // justify-content: flex-start;
            // align-items: flex-start;
            width: 100%;
            // height: 400px;
            
            .item{
                min-width: 200px;
                display: inline-flex;
                align-items: center;
                label{
                    width: 108px;
                    height: 36px;
                    line-height: 36px;
                    padding: 0 12px;
                    text-align: right;
                }
                .title{
                    padding: 0 12px;
                }
            }
            .all-item{
                display: flex;
            }
            .select-item{
                align-items: flex-start;
            }
            .all {
                width: 100%;
            }
            .falls-box{
                -moz-column-count:2;
                -webkit-column-count:2;
                column-count:2;
                -moz-column-gap:1;
                -webkit-column-gap:0;
                column-gap:0;
                .falls-item{
                    -moz-page-break-inside:avoid;
	                -webkit-column-break-inside:avoid;
                    break-inside:avoid;
                    width: 100%;
                }
            }

            label{
                //text-align: right;
                display: block;
            }

            ::v-deep .el-collapse-item__header{
                font-weight: bolder;
            }

            ::v-deep .el-collapse-item__wrap{
               padding: 10px 0 0 20px; 
               background:#f5f8fd
            }

            ::v-deep .el-collapse-item__content{
                padding-bottom: 0;
            }
        }

        .card{
            margin-bottom: 10px;
            ::v-deep .el-card__header{
                padding: 4px 10px;
            }
            ::v-deep .el-card__body{
                padding: 4px 10px;
            }
        }

        ::v-deep .el-collapse-item__header{
            height: 30px;
            line-height: 30px;
            background: #eef1f6;
            padding: 0 10px 0 20px;
        }
    }
</style>